const cce = {
  MICRO_DEPOSIT_NOT_ALLOWED: {
    message: 'Micro depósito não é permitido para sua conta',
    field: 'type',
    code: 'CCE_1'
  },
  MICRO_DEPOSIT_VALUE_NOT_ALLOWED: {
    message: 'Informar o valor do micro depósito não é permitido para sua conta',
    field: 'type',
    code: 'CCE_2'
  }
};

module.exports = cce;
